import { useProduct } from 'components/products/context';
import { Clickable } from 'phoenix-components';
import cx from 'classnames';
import { colorSelectIcon } from 'components/shared/Icons/Product';
import { useLanguageLoader } from 'contexts/language';
import { useField } from 'formik';
import styles from 'styles/shop/product.module.css';

export function ColorBox() {
  const product = useProduct();
  const { colors = [] } = product;
  const lang = useLanguageLoader();
  const [{ value: color }, , { setValue: setColor }] = useField('colorId');

  if (colors.length === 0) {
    return null;
  }

  return (
    <>
      <div className={cx(styles.key, styles.noBorder)}>
        {lang('store.words.selectColor')}
      </div>
      <div className={styles.flex1}>
        {colors.map((x, i) => (
          <Clickable
            key={i}
            className={styles.outer}
            style={{
              background: x.hex
            }}
            onClick={() => {
              setColor(x?.hex);
            }}
          >
            <div
              className={cx(color === x?.hex ? styles.active : styles.notActive)}
            >
              {color === x?.hex && colorSelectIcon()}
            </div>
          </Clickable>
        ))}
      </div>
    </>
  );
}
